module.exports = __webpack_public_path__ + "static/pesantren-malang-6ca289a100add705a95596383e0a996d.png";